import { IAccessRepository } from "./AccessRepository.types";
import { IAccess, IAccessListItem, AccessListItemResponseType, AccessResponseType } from "@/entity/salons/access.types";
import { AccessUpdateRequestType } from "@/form/salonGeneral/accessUpdate.types";
import { AccessRequestType } from "@/form/salonGeneral/access.types";
import Access from "@/entity/salons/access";
import Api from "@/repository/api";
import qs from "qs";
import {PaginationRequestType} from "@/entity/common/pagination.types";
import {ResponseDataType} from "@/form/form.types";

export class AccessRepository implements IAccessRepository {
    async fetchAll(data?: FormData): Promise<IAccess> {
        const response = await Api.get(`/salons/access_data/get`, {params: data, paramsSerializer: function paramsSerializer(params) {
            return new URLSearchParams(params).toString()
        }});
        const responseData = response.data as AccessResponseType;
        return new Access(responseData);
    }
    async fetchData(data: PaginationRequestType): Promise<IAccessListItem> {
        const response = await Api.get(`/salons/access_data/get`, {params: data, paramsSerializer: function paramsSerializer(params) {
                return qs.stringify(params, {arrayFormat: 'repeat'})
            }});
        const responseData = response.data as AccessResponseType;
        return new Access(responseData).data[0];
    }
    async create(data: AccessRequestType): Promise<ResponseDataType> {
        const response = await Api.post(`/salons/access_data/create`, data);
        return response.data;

    }
    async update(data: AccessUpdateRequestType): Promise<ResponseDataType> {
        const response = await Api.post(`/salons/access_data/update`, data);
        return response.data;

    }
    async delete(data: { id: number }): Promise<ResponseDataType> {
        const response = await Api.post(`/salons/access_data/delete`, data);
        return response.data;
    }
}
